(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-collections-vedettes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Matches the CSS hover gate: only real pointer/mouse devices get the
    // swap-on-hover video, so it never fires on a mobile tap.
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    document.querySelectorAll('.collections-showcase__tile').forEach(function (tile) {
      var video = tile.querySelector('.collections-showcase__video');
      if (!video) return;

      var play = function () {
        // Resetting currentTime before metadata has finished loading can
        // throw in some browsers, which silently aborts the play() call
        // right after it on the same line — safe to just play from wherever
        // it left off since it loops anyway.
        try {
          video.currentTime = 0;
        } catch (e) {}
        video.play().catch(function () {});
      };
      var stop = function () {
        video.pause();
      };

      tile.addEventListener('mouseenter', play);
      tile.addEventListener('mouseleave', stop);
      tile.addEventListener('focus', play);
      tile.addEventListener('blur', stop);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
